module.exports = __webpack_public_path__ + "static/img/loan.8015a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/loan.jpg
// module id = p2VZ
// module chunks = 1